var map = {
  "./pt.po": [
    "5621",
    [
      710
    ]
  ],
  "./es.po": [
    "5949",
    [
      110
    ]
  ],
  "./en.po": [
    "2010",
    [
      7
    ]
  ],
  "./da.po": [
    "7550",
    [
      11
    ]
  ],
  "./fr.po": [
    "4905",
    [
      770
    ]
  ],
  "./it.po": [
    "8468",
    [
      477
    ]
  ],
  "./de.po": [
    "610",
    [
      271
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 2981;
module.exports = __rspack_async_context;
